import { AbstractControl, ValidationErrors } from '@angular/forms';

export function noWhitespaceValidator(
    control: AbstractControl
): ValidationErrors | null {
    if (control.value?.toString().trim().length === 0) {
        return { noWhitespace: true };
    }
    return null;
}
